import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import InfiniteScrollHelper from './Helper';

function Placeholder(props) {
    const { height, index } = props;

    return (
        <div
            style={{ height: `${height}px` }}
            key={index}
        />
    );
}

Placeholder.propTypes = {
    height: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
};

export default class InfiniteScrollAnyTable extends InfiniteScrollHelper {
    static displayName = displayName('TableView/InfiniteScroll/AnyTable');

    static propTypes = {
        ...InfiniteScrollHelper.propTypes,
        className: PropTypes.string,
    };

    static defaultProps = { ...InfiniteScrollHelper.defaultProps };

    renderScroll() {
        const { topHeight, bottomHeight } = this.calculatePusherHeights();

        const children = this.getChildren({ placeholder: Placeholder });

        return (
            <div className={this.props.className}>
                <div style={{ height: topHeight }} />
                {children}
                <div style={{ height: bottomHeight }} />
            </div>
        );
    }
}
